import {
    $http
} from "@/assets/js/appFunc";
import generalStore from "@/store";

export const getAllTasks = (context, payload) => {
    const params = {
        type: "POST",
        url: "/engine/task/list",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const getTaskInformation = (context, data) => {
    const taskId = data && data.taskId ? data.taskId : window.localStorage.getItem("taskId");
    const req = {
        type: "GET",
        url: `/engine/task/get/by/${taskId}`,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                resolve(rsp.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getSelfTaskInfo = () => {
    const req = {
        type: "GET",
        url: "/engine/task/self-service-task-info",
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                resolve(rsp.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getMyTeamGroups = (context, userId) => {
    const params = {
        type: "GET",
        url: `/identity/tenant/appGroup/getGroupsForManager/${userId}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const getAllFilteredTasks = (context, payload) => {
    const url = (payload.type === "teamsTasks" || payload.type === "completedTeamsTasks") ? "/engine/task/myTeamTasks" : "/engine/task/openOrCompleted";
    const params = {
        type: "POST",
        url,
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                console.log(error);
                reject(error);
            }
        );
    });
};

export const getUserDetails = () => new Promise((resolve, reject) => {
    $http({
        url: "/identity/tenants/users/profile",
        type: "GET",
        data: ""
    }, true).then(rsp => {
        generalStore().commit("userProfile/setUserDetails", rsp.data);
        resolve(rsp.data);
    }).catch(e => {
        reject(e);
    });
});

export const saveTasksSortAndColumns = (context, data) => {
    const inferfaceType = data.type;
    const req = {
        type: "POST",
        url: `/engine/task/settings/${inferfaceType}`,
        data
    };
    return $http(req, true);
};

export const getSortAndColumns = (context, data) => {
    const inferfaceType = data;
    const req = {
        type: "GET",
        url: `/engine/task/settings/${inferfaceType}`,
        data
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                resolve(rsp.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};
